import { Tee } from "./teechart.js"

export default {
	...Tee
}
